import Template from './Template'
import { PlansScope } from "./Sidebar/Menu"

export const routesToScope = {
  '/booking/reservations': PlansScope.ReservationList,
  '/clients': PlansScope.Clients,
  '/templates': PlansScope.MessageTemplates,
  '/price/set': PlansScope.SetPrices,
  '/price/configuration': PlansScope.PricingConfig,
  '/price/prepayment': PlansScope.Prepayment,
  '/price/additional': PlansScope.AdditionalServices,
  '/statistics/overview': PlansScope.Statistics,
  '/finance/report': PlansScope.FinancialReport,
  '/statistics/room': PlansScope.RoomReport,
  '/statistics/reservations': PlansScope.OccupancyReport,
  '/statistics/local-tax-report': PlansScope.LocalTaxReport,
  '/statistics/payments': PlansScope.PaymentList,
  '/statistics/book': PlansScope.LodgingBook,
  '/booking/export': PlansScope.ReservationExport,
  '/invoice/open': PlansScope.InvoiceOpen,          // verify the exact path if different
  '/invoice-info': PlansScope.InvoiceOpen,          // verify the exact path if different
  '/invoice/taxes': PlansScope.Taxes,
  '/invoice/rates': PlansScope.TaxRates,
  '/widgets': PlansScope.ReservationSystemConfig,
  '/price/method': PlansScope.PaymentMethods,
  '/offer/facilities': PlansScope.Amenities,
  '/booking/notifications': PlansScope.Notifications,
  '/widgets/license': PlansScope.LicenseNumber,
  '/integration/airbnb': PlansScope.Airbnb,
  '/integration/booking-connect': PlansScope.BookingCom,
  '/integration/icalendar': PlansScope.ICalendar,
  '/employees': PlansScope.Employees,
}

export default Template
